<script setup lang="ts">
import {ArrowNarrowRight, DotsVertical} from "utruckin-icons";
import {IMessageHistory} from "@/types/main";

const props = withDefaults(
    defineProps<{
      history: IMessageHistory[],
      lastText: string,
      lastTime: string,
      lastId: number
    }>(),
    {
      history: undefined,
      lastText: "",
    }
)

const emit = defineEmits<{
  (e: 'showHistory', history: IMessageHistory[]): void
}>()

const showHistory = () => {
  let newHistory: IMessageHistory[] = [...props.history];
  newHistory.push({
    id: props.lastId,
    edited_at: props.lastTime,
    old_text: props.lastText,
  })

  const lastEditedAt = newHistory[newHistory.length - 1].edited_at;
  for (let i = newHistory.length - 1; i > 0; i--) {
    newHistory[i].edited_at = newHistory[i - 1].edited_at;
  }

  newHistory[0].edited_at = lastEditedAt;

  emit('showHistory', newHistory)
}
</script>

<template>
  <div class="f-ui-edited-message">
    <span class="first">{{ history[0].old_text }}</span>
    <ArrowNarrowRight :size="16"/>
    <span class="last">{{ lastText }}</span>

    <div class="additional" @click="showHistory">
      <DotsVertical :size="16"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.f-ui-edited-message {
  display: flex;
  gap: 8px;
  align-items: center;
  color: var(--color-label);
  position: relative;
  width: 100%;

  .first, .last {
    max-width: 35%;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .first {
    color: var(--color-secondary-label);
  }

  .additional {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid var(--color-border);
    position: relative;
    z-index: 1;

    &:hover {
      background-color: var(--color-bg-secondary);
    }
  }
}
</style>